<!-- 搜索条件大于6个时，使用此组件-->
<template>
  <div class="baseSearchBox">
    <el-form :inline="true" size="small"> 
      <el-form-item>
        <el-select clearable v-model="searchType" filterable placeholder="请选择搜索项" value-key="value"
          @change="onChangeSelect">
          <el-option v-for="item in searchList" :key="item.value" :label="item.label" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="searchType!=''">
        <el-select filterable v-model="searchParams[curSelect.paramName]" :placeholder="'请选择'+ curSelect.label"
          v-if="curSelect.inputType == 'select'&&!curSelect.remote">
          <el-option v-for="item in curSelect.optionData" :disabled='item.disabled' :key="item.value"
            :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="searchParams[curSelect.paramName]" :placeholder="'请选择'+ curSelect.label" remote filterable
          v-if="curSelect.inputType == 'select' && curSelect.remote">
          <el-option v-for="item in curSelect.optionData" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select filterable v-model="searchParams[curSelect.paramName]" :placeholder="'请选择'+ curSelect.label"
          v-if="curSelect.inputType == 'selectDisease'">
          <el-option v-for="el in selectdiseaseList" :key="el.value" :label="el.label" :value="el.value">
          </el-option>
        </el-select>
        <selectHospital v-if="curSelect.inputType == 'hospital'" :placeholder="'请选择'+ curSelect.label"
          @getChooseHospitalId="getChooseHospitalId" ref="selectHospitalId"></selectHospital>
        <el-input v-model.trim="searchParams[curSelect.paramName]" :placeholder="'请输入'+curSelect.label"
          prefix-icon="el-icon-search" v-if="curSelect.inputType == 'input'" autocomplete="off"
          :maxlength="curSelect.maxlength?curSelect.maxlength:'15'"></el-input>
        <el-date-picker v-if="curSelect.inputType == 'datetimerange'" v-model="searchParams[curSelect.paramName]"
          value-format="yyyy-MM-dd" :default-time="['00:00:00']" clearable align="center" popper-class="popper-class"
          type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
        <div v-if="curSelect.inputType == 'paymentMethods'" class="pay-method">
          <el-select filterable multiple clearable collapse-tags v-model="searchParams[curSelect.paramName]"
            :placeholder="'请选择'+ curSelect.label">
            <el-option v-for="el in curSelect.optionData" :key="el.value" :label="el.label" :value="el.value">
            </el-option>
          </el-select>
          <div class="wechat-paymethod"
            v-if="searchParams[curSelect.paramName] && searchParams[curSelect.paramName].length > 0 && searchParams[curSelect.paramName].indexOf(1) > -1">
            <label>实付金额区间：</label>
            <el-input placeholder="请输入实付金额" v-model="searchParams[curSelect.paramStartPay]" type="number"
              style="width: 120px">
              <template slot="append">元</template>
            </el-input>
            <span> - </span>
            <el-input placeholder="请输入实付金额" v-model="searchParams[curSelect.paramEndPay]" type="number"
              style="width: 120px">
              <template slot="append">元</template>
            </el-input>
          </div>
        </div>
      </el-form-item>
      <template v-if="tagList && tagList.length">
        <el-form-item v-for="(item,index) in tagList" :key='index'>
          <el-tag class="searchTag" :class="setWidth?'setTop':''" size="small" closable @close="tagClose(index)">
            <span :class="setWidth?'setWidth':''">{{item.label}}</span>
          </el-tag>
        </el-form-item>
      </template>
      <el-form-item>
        <el-button @click="onResetClick">重置</el-button>
        <el-button type="primary" @click="onSearchClick">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-form :inline="true" size="small" v-if="rightEventList.length>0">
      <el-form-item>
        <el-button type="primary" :plain='item.plain' v-for="(item,index) in rightEventList" :key='index'
          @click="rightFunc(item)">{{item.eventName}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { api_get_disease_type } from "@/api/ManagementPlan";
export default {
  props: {
    //使用可参考termList.vue
    // *必填项
    setWidth: {
      type: Boolean,
      default: false
    },
    searchList: {
      type: Array,
      default: [
        /* {
          label: "选择条件下拉label", // * 
          value: 1, //选择条件下拉value *
          paramName: "xx", //xx 传入后端参数名称 *
          inputType: "select", //条件类型 select input datetimerange * 根据需求继续累加
          optionData: [ // inputType为select时对应条件下拉选择项 
            {
              label: "label",
              value: "value"
            }
          ]
        },
        {
          label: "时间范围",
          value: 7,
          paramName: "timeRange", // 必须为timeRange
          inputType: "datetimerange", //时间范围
          paramstartTime: "xxx", //xxx 传入后端开始时间字段名称
          paramEndTime: "xxxx" //xxxx 传入后端结束时间字段名称
        }
         */
      ],
      require: true
    },
    rightEventList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchType: {},
      selectdiseaseList: [], //主适配病种
      curSelect: {}, //当前选择的条件
      tagList: [], //已搜索条件
      searchParams: {}, //传入字段
      diseaseFlag: false //是否需要获取适配病种数据
    };
  },
  watch: {
    searchList: {
      handler(val) {
        if (val.length) {
          for (let index = 0; index < val.length; index++) {
            if (val[index].default || val[index].default == 0) {
              this.curSelect = val[index];
              this.searchType = val[index];
              this.searchParams[val[index].paramName] = val[index].default;
              this.onSearchClick();
            }
          }
        }
      },
      immediate: true
    }
  },
  created() {
    this.searchList.map(item => {
      if (item.inputType == "selectDisease") {
        this.diseaseFlag = true;
      }
    });
    if (this.diseaseFlag) {
      this.getDisease();
    }
  },
  methods: {
    getDisease() {
      api_get_disease_type().then(res => {
        if (res.code == 0) {
          this.selectdiseaseList = res.data.map(item => {
            return {
              value: item.id,
              label: item.suborderName
            };
          });
        }
      });
    },
    getChooseHospitalId(val, name) {
      for (let index = 0; index < this.searchList.length; index++) {
        if (this.searchList[index].inputType == "hospital") {
          this.searchParams[this.searchList[index].paramName] = val;
          this.searchParams.hospitalName = name;
        }
      }
    },
    deleteTag(key) {
      this.tagList.map((item, eq) => {
        if (item.paramName == key) {
          //删除时间范围开始及结束时间值
          // if (item.paramName == "timeRange") {
          //   this.searchList.map(items => {
          //     if (items.value == item.type) {
          //       delete this.searchParams[items.paramstartTime];
          //       delete this.searchParams[items.paramEndTime];
          //     }
          //   });
          // }
          delete this.searchParams[item.paramName];
          this.tagList.splice(eq, 1);
        }
      });
    },
    rightFunc(item) {
      this.$emit("rightFunc", item);
    },
    //选择条件
    onChangeSelect(item) {
      this.curSelect = item;
    },
    //搜索
    onSearchClick() { 
      if (this.curSelect != {}) {
        let obj = this.searchParams;
        if (this.curSelect.inputType == "select") {
          this.searchList.map(item => {
            if (item.paramName && item.paramName == this.curSelect.paramName) {
              item.optionData.map(itemVal => {
                if (itemVal.value == obj[item.paramName]) {
                  this.handleTag(itemVal.label);
                }
              });
            }
          });
        } else if (this.curSelect.inputType == "input") {
          this.handleTag(obj[this.curSelect.paramName]);
        } else if (this.curSelect.inputType == "selectDisease") { 
          this.selectdiseaseList.map(itemVal => {
            if (itemVal.value == obj[this.curSelect.paramName]) {
              this.handleTag(itemVal.label);
            }
          }); 
        } else if (this.curSelect.inputType == "hospital") {
          this.handleTag(obj.hospitalName);
        } else if (this.curSelect.inputType == "paymentMethods") {
          let label = [];
          obj.paymentMethods.map((item, key) => {
            switch (item) {
              case 1:
                label[key] =
                  obj.lowPayAmount && obj.highPayAmount
                    ? `微信支付:${obj.lowPayAmount}元-${obj.highPayAmount}元`
                    : "微信支付";
                break;
              case 6:
                label[key] = "无支付";
                break;
              case 7:
                label[key] = "患者组织赠送";
                break;
              case 9:
                label[key] = "商品赠送";
                break;
            }
          });
          this.handleTag(label.join(","));
          // if (obj.lowPayAmount && obj.highPayAmount) {
          //   this.handleTag(`${obj.lowPayAmount}元-${obj.highPayAmount}元`);
          // }
        } else if (this.curSelect.inputType == "datetimerange") {
          obj[this.curSelect.paramstartTime] = this.curSelect.isTime
            ? obj[this.curSelect.paramName][0] + " 00:00:00"
            : obj[this.curSelect.paramName][0];
          obj[this.curSelect.paramEndTime] = this.curSelect.isTime
            ? obj[this.curSelect.paramName][1] + " 23:59:59"
            : obj[this.curSelect.paramName][1];
          this.handleTag(
            obj[this.curSelect.paramstartTime] +
              "~" +
              obj[this.curSelect.paramEndTime]
          );
        }
      }
      this.$emit("getSearchObj", this.searchParams);
    },
    handleTag(name) {
      if (this.tagList.length) {
        this.tagList.map((tag, eq) => {
          if (tag.type == this.searchType.value) {
            this.tagList.splice(eq, 1);
          }
        });
      }
      if (name) {
        this.tagList.push({
          label: name,
          type: this.searchType.value,
          paramName: this.curSelect.paramName
        });
      }
      if (this.curSelect.inputType == "datetimerange") {
        delete this.searchParams[this.curSelect.paramName];
      }
      this.searchType = "";
      this.curSelect = {};
    },
    tagClose(index) {
      //移除搜索条件值
      this.tagList.map((item, eq) => {
        if (index == eq) {
          //删除时间范围开始及结束时间值
          if (item.paramName == "timeRange") {
            this.searchList.map(items => {
              if (items.value == item.type) {
                delete this.searchParams[items.paramstartTime];
                delete this.searchParams[items.paramEndTime];
              }
            });
          }
          // 支付方式
          if (item.paramName == "paymentMethods") {
            this.searchList.map(items => {
              if (items.value == item.type) {
                delete this.searchParams[items.paramStartPay];
                delete this.searchParams[items.paramEndPay];
              }
            });
          }
          delete this.searchParams[item.paramName];
        }
      });
      //移除已选择条件
      this.tagList.splice(index, 1);
      this.$emit("getSearchObj", this.searchParams);
    },
    //重置
    onResetClick() {
      this.tagList = [];
      this.searchParams = this.$options.data().searchParams;
      this.searchType = "";
      this.$emit("getSearchObj", this.searchParams);
    }
  }
};
</script>   
<style>
.baseSearchBox .el-form-item {
  margin-bottom: 5px !important;
}
</style>
<style scoped lang="less">
.setWidth {
  display: inline-block;
  max-width: 60px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.setTop{
  margin-top: 3px;
}
.baseSearchBox {
  display: flex;
  width: 100%;
  align-items: center;
  padding-bottom: 16px;
  justify-content: space-between;
}
.searchTag {
  border-radius: 11px;
  margin-right: 15px;
  display: flex;
  align-items: center;
}
.pay-method {
  display: flex;
  .wechat-paymethod {
    margin-left: 10px;
    color: #333333;
    font-size: 14px;
  }
}
</style>